import { Container, makeStyles, Paper, Typography } from '@material-ui/core'
import _ from 'lodash'
import { FC, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import Form from '../component/um/settingDocument/Form'
import Dialog, { DialogType } from '../control/dialog/dialog'
import useTranslate from '../i18n/useTranslate'
import {
    GetDocumentResponse,
    useSettingDocument,
    AddDocumentRequest,
    UplodeFileDocType,
} from '../services/um/useSettingDocument'
import useAuthenStore from '../stores/authen/authenStore'

interface SettingDocumentAddProps {}

const SettingDocumentAdd: FC<SettingDocumentAddProps> = ({}) => {
    const classes = useStyle()
    const translate = useTranslate()
    const history = useHistory()
    const { postSettingDocument } = useSettingDocument()
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const authenStore = useAuthenStore()
    const [initialUploadFile, setInitialUploadFile] = useState<any>()

    const topicInitial = [
        {
            id: String(_.uniqueId()),
            name_th: 'ภาษาไทย',
            name_en: 'Thai',
        },
        {
            id: String(_.uniqueId()),
            name_th: 'ภาษาอังกฤษ',
            name_en: 'English',
        },
    ]

    const initialUpload = async (initDocumentInfo?: GetDocumentResponse['documentInfo']) => {
        let uploadFileInit = topicInitial?.map((itm: any) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    documentTopicID: itm.id,
                },
            }
        }) as Array<UplodeFileDocType>

        uploadFileInit?.forEach((itm: UplodeFileDocType) => {
            initDocumentInfo?.forEach((docInfo, index) => {
                if (docInfo.uploadFileObj?.documentTopicID === itm.uploadFileObj?.documentTopicID) {
                    if (!docInfo.uploadFileObj?.fileList.length) {
                        itm.uploadFileObj?.fileList.push({
                            ...docInfo.uploadFileObj?.fileList[index],
                            fileID: `${docInfo.uploadFileObj?.fileList[index].fileID}`,
                            documentTopicID: docInfo.uploadFileObj?.fileList[index].documentTopicID as number,
                            fileToken: `${docInfo.uploadFileObj?.fileList[index].fileToken}`,
                            filename: `${docInfo.uploadFileObj?.fileList[index].filename}`,
                        })
                    }
                }
            })
        })

        setInitialUploadFile(uploadFileInit)
    }

    let initialValues: GetDocumentResponse = {
        code: null,
        submittedTypeID: null,
        nameTH: null,
        nameEN: null,
        shortNameTH: null,
        shortNameEN: null,
        isDisplayDocument: true,
        documentInfo: initialUploadFile,
    }

    const onBack = () => {
        history.goBack()
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const onSave = async (values: GetDocumentResponse) => {
        const param: AddDocumentRequest = {
            nameTH: values.nameTH,
            nameEN: values.nameEN,
            shortNameTH: values.shortNameTH,
            shortNameEN: values.shortNameEN,
            code: values.code,
            submittedTypeID: values.submittedTypeID,
            recID: authenStore.profile.irb,
            userID: authenStore.profile.userId,
            isDisplayDocument: values.isDisplayDocument,
            documentInfo: values.documentInfo,
        }

        const result = await postSettingDocument(param)

        let optionDialog: any = {
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
            type: 'alert-message',
            onAfterClose: onBack,
        }
        if (result.status !== 1) {
            optionDialog = {
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('MESSAGE.M022'),
                type: 'alert-message',
            }
        }

        setConfigDialog(optionDialog)
    }

    const handleClickSubmit = async (values: GetDocumentResponse) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => onSave(values),
        })

        dialogTwoRef.current?.openDialog()
    }

    useEffect(() => {
        initialUpload()
    }, [])
    return (
        <Container maxWidth="lg">
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                {translate.get('UM.SETTINGDOCUMENT.ADD.HEADER')}
            </Typography>
            <Paper className={classes.paper}>
                <Form
                    onClickBack={onBack}
                    initialValues={initialValues}
                    onSubmit={handleClickSubmit}
                    initialUploadFile={initialUploadFile}
                    topicInitial={topicInitial}
                />
                <Dialog onRef={onRefDialogTwo} {...configDialog} />
            </Paper>
        </Container>
    )
}
export default SettingDocumentAdd
const useStyle = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    paper: {
        width: '100%',
        padding: '20px',

        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
            margin: '0px',
        },
    },
}))
